import { createBrowserHistory } from 'history';
const s3_hosting_path = require('./constants/s3.js');

export const history = createBrowserHistory({
  basename: s3_hosting_path
});
